export default "__VITE_ASSET__99c09bf9__"